var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main-columns",
    {
      scopedSlots: _vm._u([
        {
          key: "rightColumn",
          fn: function() {
            return [_c("notifications")]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "va-title" }, [
        _vm._v(_vm._s(_vm.$t("roomWizard.changeLicense")))
      ]),
      _c("div", { staticClass: "mb-6" }, [
        _vm._v(_vm._s(_vm.$t("roomWizard.changeLicenseLongDescription")))
      ]),
      _vm.deviceConfiguration == undefined
        ? _c("wizard-connect", {
            attrs: { type: "ChangeLicense" },
            on: {
              onFetchConfiguration: function($event) {
                _vm.deviceConfiguration = $event
              }
            }
          })
        : _c("room-wizard", {
            attrs: {
              steps: _vm.steps,
              "device-configuration": _vm.deviceConfiguration,
              update: true
            }
          }),
      _c(
        "div",
        { staticClass: "d-flex justify-right mt-6" },
        [
          _vm.deviceConfiguration != undefined
            ? _c("va-button", {
                attrs: { cta: _vm.$t("roomWizard.reset") },
                on: {
                  click: function($event) {
                    _vm.deviceConfiguration = undefined
                    _vm.$router.push("/activate")
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }